import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import { LATEST_NEWS_FETCHED } from 'app/features/news/actionTypes';

const latestNewsFetched = createAction(LATEST_NEWS_FETCHED);

function fetchLatestNews() {
  return (dispatch, _, { api }) =>
    api.fetchLatestNews().then(compose(dispatch, latestNewsFetched));
}

export { fetchLatestNews };
